import { useCallback, useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';
import { isNil } from 'lodash';
import { authentificationSelector } from 'modules/taboola-common-frontend-modules/authentication';
import { useConsentApi } from 'services/api';
import { getAnalyticsCookies, CMP_LOCAL_STORAGE_USER_SELECTION_KEY } from './consentUtils';

export const useCookieConsent = () => {
    const isAuthenticated = useSelector(authentificationSelector);
    const [hasAnalyticCookies, setHasAnalyticCookies] = useState();
    const { exclude, include } = useConsentApi();

    const updateConsent = useCallback(() => {
        if (hasAnalyticCookies) {
            include();
            return;
        }

        exclude();
    }, [exclude, include, hasAnalyticCookies]);
    const { mutate } = useMutation(updateConsent);

    useEffect(() => {
        if (!isAuthenticated || isNil(hasAnalyticCookies)) {
            return;
        }
        mutate();
    }, [isAuthenticated, hasAnalyticCookies, mutate]);

    const hasCmp = !!window.__cmp;

    useEffect(() => {
        if (!hasCmp || !isAuthenticated) {
            return;
        }

        const callback = () => {
            const cmpData = window.__cmp('getCMPData');
            if (!cmpData || !cmpData?.consentExists) {
                return;
            }
            const value = getAnalyticsCookies(cmpData);

            setHasAnalyticCookies(value);
            localStorage.setItem(CMP_LOCAL_STORAGE_USER_SELECTION_KEY, value ? true : '');
        };

        callback();
        window.__cmp('addEventListener', ['consent', callback, false], null);
    }, [isAuthenticated, hasCmp]);
};
